import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'sun-icon',
  templateUrl: './sun-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SunIconComponent {}
